var mobile = require('is-mobile')

export const isMobile = mobile({featureDetect: true, tablet: true}) || window.screen.width < 960

export const isMobileApp = window.navigator.userAgent.includes('BenchmarcApp')
